import { useInventoryPaginationContext } from "domain/Inventory";
import React, { useEffect } from "react";
import { ScrollPosition, Spinner } from "shared";
import { ItemsTable } from "domain/Inventory";
import { useLocalStorage } from "domain/App/hooks";
import { initialDisplayedColumns, DISPLAYED_COLUMNS } from "shared/constants/constants";
import { FiltersGroup, useFiltersContext } from "domain/Filters";

export const WarehousePage = () => {
  const { items, isLoading, updateSelection, totalItems } = useInventoryPaginationContext();
  const { applyPendingFilters, setMandatoryFilters } = useFiltersContext();
  const [displayedColumns, setDisplayedColumns] = useLocalStorage(DISPLAYED_COLUMNS, initialDisplayedColumns);

  useEffect(() => {
    setDisplayedColumns((prev) => ({
      ...prev,
      assignedTo: false,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const mandatory = { isAssigned: true };
    setMandatoryFilters(mandatory);

    applyPendingFilters();

    return () => {
      setMandatoryFilters({});
    };
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="home-header_left">
        <FiltersGroup hideUnassignedSwitch/>
      </div>
      {isLoading ? (
        <div className="items-table__loading">
          <Spinner size="large" />
        </div>
      ) : items ? (
        <ScrollPosition uniqueId="dashboard-page">
          <ItemsTable
            displayedColumns={displayedColumns}
            data={items}
            isReadOnly={false}
            updateSelection={updateSelection}
            totalItems={totalItems}
            isUrlDriven
          />
        </ScrollPosition>
      ) : null}
    </>
  );
};
